import { red } from '@mui/material/colors';
import { components } from './components';

const themeOptions = {
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    fontSize: 14,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontSize: '14px' },
    button: { fontWeight: 600 },
  },

  shape: { borderRadius: 12 },

  status: { danger: red[500] },
  components: { ...components },
};

export default themeOptions;
